export default __webpack_public_path__ + "static/media/molly-white.9b588576.svg";